import * as React from 'react';
import LayerParams from './LayerParams';
const SEPARATOR = ',';
const useSelectedStands = (map, selectedStandIds) => {
    const selectedStandIdsHash = selectedStandIds === null || selectedStandIds === void 0 ? void 0 : selectedStandIds.concat().sort((a, b) => a < b ? -1 : 1).join(SEPARATOR);
    React.useEffect(() => {
        if (!map || !selectedStandIdsHash)
            return;
        const localIds = selectedStandIdsHash === null || selectedStandIdsHash === void 0 ? void 0 : selectedStandIdsHash.split(SEPARATOR);
        const isStyleLoaded = map.isStyleLoaded();
        const setSelected = (flag) => {
            localIds === null || localIds === void 0 ? void 0 : localIds.forEach(id => {
                map.setFeatureState({ id, source: LayerParams.sourceId }, { selected: flag });
            });
        };
        const setTrueSelected = () => {
            if (map.getSource(LayerParams.sourceId))
                setSelected(true);
        };
        // Listen styledata event to solve problem with init map
        if (!isStyleLoaded)
            map.on('styledata', setTrueSelected);
        // update state only when map style loaded!!!
        if (isStyleLoaded)
            setSelected(true);
        return () => {
            setSelected(false);
            map.off('styledata', setTrueSelected);
        };
    }, [map, selectedStandIdsHash]);
};
export default useSelectedStands;
